import React from 'react'
import { LoadingAnimation } from '@chegg/ui-agnostic'
import { fanta } from '@chegg/fanta'
import { overlay, pushup } from './LoadingOverlay.css'
import { LegalCopy } from './LegalCopy'
import { PROCESSING_PAPER_COPY } from '../constants'

export interface LoadingOverlayProps {
  uploading: boolean
  displayLegal: boolean
  children?: React.ReactElement
}

const LoadingOverlay: React.SFC<LoadingOverlayProps> = ({ uploading, displayLegal, children }) => {
  if (!uploading) return <React.Fragment>{children}</React.Fragment>

  return (
    <React.Fragment>
      <div className={overlay}>
        <div>
          <LoadingAnimation color={fanta.colors.cheggOrange} />
        </div>
        <h3>{PROCESSING_PAPER_COPY}</h3>
        <div className={pushup} />
        {displayLegal && <LegalCopy bottom />}
      </div>
      {children}
    </React.Fragment>
  )
}

export default LoadingOverlay
